module.exports = __webpack_public_path__ + "img/mdv.3c896bfd.svg";